import { useActiveLayerContext } from '@/context/__project__/ActiveLayerContext'
import { useBuilderActionContextV2 } from '@/context/__project__/BuilderActionContextV2'
import { useCompContext } from '@/context/__project__/CompContext'
import { useBreakpoint } from '@/hooks/useBreakpoint'

import { CompFabWrapperCore } from '../core/fab/wrapper'
import { CompFab } from './CompFab'

const CompFabWrapper = () => {
  const compContext = useCompContext()
  const { activeLayer } = useActiveLayerContext()
  const actionContext = useBuilderActionContextV2()

  const { isNavigationBarBottom, menuHeight, isSticky, isShowNavbar } = useBreakpoint()

  const showNavbar = isShowNavbar && isNavigationBarBottom
  const navbarHeight = isSticky ? menuHeight : '0px'

  return (
    <CompFabWrapperCore infos={{ ...compContext, activeLayer }} action={actionContext}>
      {(props) => (
        <CompFab
          {...(props as any)}
          isNavigationBarBottom={isNavigationBarBottom}
          menuHeight={navbarHeight}
          showNavbar={showNavbar}
          navbarHeight={navbarHeight}
        />
      )}
    </CompFabWrapperCore>
  )
}


export default CompFabWrapper